import { schema } from 'normalizr'


// Ranks
export const rankSchema = new schema.Entity('ranks', {}, {
    idAttribute: rank => rank.id
});

export const rankList = new schema.Array(rankSchema);


// Users
export const userSchema = new schema.Entity('users', {
    rank: rankSchema,
}, {
    idAttribute: user => user.id,
});

export const presenceSchema = new schema.Entity('presences', {
    user: userSchema,
}, {
    idAttribute: presence => presence.id,
});

export const userOnlineList = new schema.Array(presenceSchema);

// Awards
export const awardSchema = new schema.Entity('awards', {}, {
    idAttribute: award => award.id
});
export const awardCategorySchema = new schema.Entity('awardCategories', {
    awards: [awardSchema],
}, {
    idAttribute: awardCategory => awardCategory.id
});

export const awardCategoryList = new schema.Array(awardCategorySchema);

export const awardRecipientSchema = new schema.Entity('awardRecipients', {
    award: awardSchema,
    recipientDetail: userSchema,
}, {
    idAttribute: awardRecipient => awardRecipient.id
});

export const awardRecipientList = new schema.Array(awardRecipientSchema);

export const awardList = new schema.Array(awardSchema);

// Chapters
export const chapterSchema = new schema.Entity('chapters', {
    awardCategories: [awardCategorySchema],
}, {
    idAttribute: chapter => chapter.id
});

export const chapterList = new schema.Array(chapterSchema);



export const chapterMemberSchema = new schema.Entity('chapterMembers', {
    member: userSchema,
    //chapter: chapterSchema,
    //division: chapterDivisionSchema,
}, {
    idAttribute: chapterMember => chapterMember.id
});

export const chapterMemberList = new schema.Array(chapterMemberSchema);

// Divisions
const chapterDivisionSchema = new schema.Entity('chapterDivisions', {
    members: chapterMemberList,
}, {
    idAttribute: division => division.id
});
export const chapterDivisionList = new schema.Array(chapterDivisionSchema);

chapterDivisionSchema.define({ children: chapterDivisionList });
export { chapterDivisionSchema };



export const awardSummaryList = new schema.Array(chapterSchema);


// News
export const newsSchema = new schema.Entity('news', {
    article: {
        author: userSchema
    },
    chapter: chapterSchema,
}, {
    idAttribute: news => news.slug
});

export const newsList = new schema.Array(newsSchema);


// Feed
export const feedSchema = new schema.Entity('feed',
    {
        user: userSchema,
        chapter: chapterSchema,
        rank: rankSchema,
    }, {
    idAttribute: item => item.id
});

export const feedList = new schema.Array(feedSchema);


// Applications


export const applicationSchema = new schema.Entity('applications', {
    user: userSchema,
    history: [
        { user: userSchema }
    ]
}, {
    idAttribute: application => application.id
});

export const applicationList = new schema.Array(applicationSchema);

export const applicationQuestionSchema = new schema.Entity('applicationQuestions', {}, {
    idAttribute: question => question.id
});

export const applicationQuestionList = new schema.Array(applicationQuestionSchema);

export const applicationInterestSchema = new schema.Entity('applicationInterests', {}, {
    idAttribute: interest => interest.id
});

export const applicationInterestList = new schema.Array(applicationInterestSchema);


// Notifications

export const notificationSchema = new schema.Entity('notifications', {
    award: awardSchema,
    creator: userSchema,
    application: applicationSchema,
});

export const notificationList = new schema.Array(notificationSchema);


// Comments

export const commentSchema = new schema.Entity('comments', {
    user: userSchema
}, {
    idAttribute: comment => comment.id
});

export const commentList = new schema.Array(commentSchema);

// Media

// Quotes

export const quoteSchema = new schema.Entity('quotes', {
    poster: userSchema,
    involved: [userSchema]

}, {
    idAttribute: quote => quote.id
});

export const quotesList = new schema.Array(quoteSchema);

// Codex

const codexSchema = new schema.Entity('codex', {
    author: userSchema,
    lastUpdatedBy: userSchema,
    deletedBy: userSchema,
}, {
    idAttribute: codex => codex.id
});

export const codexList = new schema.Array(codexSchema);

codexSchema.define({ children: codexList });

export { codexSchema }

// DKP

export const dkpSchema = new schema.Entity('dkp', {
    chapter: chapterSchema,
}, {
    idAttribute: dkp => dkp.id
});

export const dkpList = new schema.Array(dkpSchema);

export const dkpStandingsSchema = new schema.Entity('dkpStandings', {
    user: userSchema,
}, {
    idAttribute: dkpStanding => dkpStanding.id
});

export const dkpStandingsList = new schema.Array(dkpStandingsSchema);

export const locationSchema = new schema.Entity('locations', {

}, {
    idAttribute: location => location.id
});

export const locationList = new schema.Array(locationSchema);

export const itemSchema = new schema.Entity('items', {

}, {
    idAttribute: item => item.id
});

export const itemList = new schema.Array(itemSchema);

export const entitySchema = new schema.Entity('entities', {

}, {
    idAttribute: entity => entity.id
});

export const entityList = new schema.Array(entitySchema);

export const eventAttendanceSchema = new schema.Entity('attendees', {
    userDetail: userSchema,
}, {
    idAttribute: attendee => attendee.id
});

export const eventAttendanceList = new schema.Array(eventAttendanceSchema);

export const eventEntitySchema = new schema.Entity('eventEntities', {
    entity: entitySchema
}, {
    idAttribute: entity => entity.id
});

export const eventEntityList = new schema.Array(eventEntitySchema);

export const eventItemSchema = new schema.Entity('eventItems', {
    item: itemSchema,
    userDetail: userSchema
}, {
    idAttribute: item => item.id
});

export const eventItemList = new schema.Array(eventItemSchema);

export const eventSchema = new schema.Entity('events', {
    createdBy: userSchema,
    eventLeaderDetail: userSchema,
    location: locationList,
    section: dkpSchema,
    attendees: eventAttendanceList,
    entities: eventEntityList,
    awardedItems: eventItemList,
}, {
    idAttribute: event => event.id
});

export const eventList = new schema.Array(eventSchema);

export const pollItemSchema = new schema.Entity('pollItems', {
}, {
    idAttribute: pollItem => pollItem.id
})

export const pollItemList = new schema.Array(pollItemSchema);

export const pollSchema = new schema.Entity('polls', {
    userDetail: userSchema,
    items: pollItemList,
}, {
    idAttribute: poll => poll.id
});

export const pollList = new schema.Array(pollSchema);

export const screenshotSchema = new schema.Entity('screenshots', {
    poster: userSchema,
    involved: [userSchema],
}, {
    idAttribute: screenshot => screenshot.id
})

export const screenshotList = new schema.Array(screenshotSchema)

export const resourceSchema = new schema.Entity('resources', {
    sectionDetail: dkpSchema
}, {
    idAttribute: resource => resource.id
})

export const resourceList = new schema.Array(resourceSchema)

export const resourceContributionSchema = new schema.Entity('resourceContributions', {
    userDetail: userSchema
}, {
    idAttribute: resource => resource.id
})

export const resourceContributionList = new schema.Array(resourceContributionSchema)


// WEBPACK FOOTER //
// ./src/redux/schemas.js